import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { ProductsService } from '../products/products.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private cookieCiencuadras: CookieCiencuadras,
    private registerService: ProductsService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token: string = this.cookieCiencuadras.getCookieCrypt('authToken');
    let request = req;
    const u: string = environment.lambdaApiUrl;
    if (request.url.indexOf(u) !== -1) {
      if (!token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Basic`,
          },
        });

        return this.getTokenFromCognito(request, next);
      } else {
        return next.handle(this.addToken(request, token));
      }
    } else {
      return next.handle(request);
    }
  }

  private getTokenFromCognito(request: HttpRequest<any>, next: HttpHandler) {
    return this.registerService.getAuthTokenService().pipe(
      switchMap((res: any) => {
        // Extraer la fecha de expiración desde el token
        const expirationDate = this.extractExpirationDate(res.access_token);
        this.cookieCiencuadras.setCookieCrypt(
          'authToken',
          res.access_token,
          expirationDate,
        );
        return next.handle(this.addToken(request, res.access_token));
      }),
      catchError((error) => next.handle(request)),
    );
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Ciencuadras-Scope': 'private',
      },
    });
  }

  private extractExpirationDate(token: string): Date {
    try {
      const base64Url = token.split('.')[1];
      if (!base64Url) throw new Error('Formato de token inválido');

      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const decodedData = JSON.parse(atob(base64));
      const expSeconds =
        decodedData.exp ?? Math.floor(Date.now() / 1000) + 3580;

      return new Date(expSeconds * 1000);
    } catch (error) {
      console.error('Error al decodificar el token:', error);
      return new Date(Date.now() + 3580 * 1000);
    }
  }
}
